import React, { useState } from 'react';

import { AlineButton, NameDialog, NameDialogVariant, useGetRoleSchema } from 'src/components';
import { useAccessGuard } from 'src/components/auth';
import { WhitePlusIcon } from 'src/components/icons/WhitePlusIcon';
import { Apollo } from 'src/gql/generated';
import { useDispatchSuccessSnack } from 'src/helpers';
import { useCreateUserDefinedRole } from 'src/hooks';
import { v4 as uuid4 } from 'uuid';

interface NewRoleButtonProps {
  disabled?: boolean;
}

export function NewRoleButton({ disabled }: NewRoleButtonProps): JSX.Element {
  const roleSchema = useGetRoleSchema();
  const [open, setOpen] = useState(false);
  const { createRole } = useCreateUserDefinedRole();
  const dispatchSuccessSnack = useDispatchSuccessSnack({
    key: uuid4(),
    message: 'Role successfully created.',
  });
  const handleOpen = useAccessGuard({
    callback: () => setOpen(true),
    minRole: Apollo.OrgRole.Admin,
  });

  async function handleCreateRole(roleName: string): Promise<void> {
    const { data } = await createRole({ variables: { input: { props: { roleName } } } });
    if (data) dispatchSuccessSnack();

    setOpen(false);
  }

  return (
    <>
      <AlineButton
        color="primary"
        disabled={disabled}
        endIcon={<WhitePlusIcon />}
        variant="contained"
        onClick={handleOpen}
      >
        New Role
      </AlineButton>
      <NameDialog
        handleClose={() => setOpen(false)}
        open={open}
        placeholder="Enter role..."
        validationSchema={roleSchema}
        variant={NameDialogVariant.RenameUserDefinedRole}
        onFormikSubmit={handleCreateRole}
      />
    </>
  );
}
